// InputClonerManager.js
export class InputClonerManager {
  constructor(input) {
    if (!(input instanceof HTMLInputElement)) {
      throw new Error('InputClonerManager ожидает элемент input.');
    }
    this.input = input;
    this.initializeCloning();
  }

  initializeCloning() {
    if (this.input.dataset.clone_value_for) {
        // console.warn('InputClonerManager clone_value_for инилициализирован')
      this.handleCloneValueFor();
    }
    if (this.input.dataset.clone_value_from) {
        // console.warn('InputClonerManager clone_value_from инилициализирован')
      this.handleCloneValueFrom();
    }
  }

  handleCloneValueFor() {
    const targetSelector = this.input.getAttribute('data-clone_value_for');
    const targetInput = document.querySelector(targetSelector) || document.querySelector(`[name="${targetSelector}"]`);

    if (!targetInput) {
      console.warn(`Целевой селектор "${targetSelector}" не найден.`);
      return;
    }

    // Устанавливаем начальное значение
    targetInput.value = this.input.value;

    // Обновляем целевой input при изменении исходного
    this.input.addEventListener('input', () => {
      targetInput.value = this.input.value;
    });
  }

  handleCloneValueFrom() {
    const sourceSelector = this.input.getAttribute('data-clone_value_from');
    const sourceInput = document.querySelector(sourceSelector) || document.querySelector(`[name="${sourceSelector}"]`);

    if (!sourceInput) {
      console.warn(`Исходный селектор "${sourceSelector}" не найден.`);
      return;
    }

    // Устанавливаем начальное значение
    this.input.value = sourceInput.value;

    // Обновляем этот input при изменении исходного
    sourceInput.addEventListener('input', () => {
      this.input.value = sourceInput.value;
    });
  }
}
